import {useQueries} from "@tanstack/react-query";
import analysisToolService from "../../../../services/web/analysis-tool-service.js";
import typePlaceService from "../../../../services/web/type-place-service.js";
import protectionProgramService from "../../../../services/web/protection-program-service.js";

export const UseFetchData = (modules) => {
    const queries = useQueries({
        queries: [
            {
                queryKey: ['reasons', {modules}],
                queryFn: async () => await analysisToolService.occurrencesReasons(modules),
            },
            {
                queryKey: ['cities'],
                queryFn: async () => await analysisToolService.citiesItems(),
            },
            {
                queryKey: ['type_place'],
                queryFn: async () => await typePlaceService.getAll()
            },
            {
                queryKey: ['layers'],
                queryFn: async () => await analysisToolService.layerItems(),
            },
            {
                queryKey: ['points'],
                queryFn: async () => await analysisToolService.pointItems(),
            },
            {
                queryKey: ['protection_programs'],
                queryFn: async () => await protectionProgramService.options()
            }
        ]
    });

    return {
        reasons: queries[0].data || [],
        cities: queries[1].data || [],
        type_place: queries[2].data || [],
        layers: queries[3].data || [],
        points: queries[4].data || [],
        protection_programs: queries[5].data || [],
    }
}